module.exports = __webpack_public_path__ + "static/img/Likwid.b3aa146.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/business/Likwid.png
// module id = tqza
// module chunks = 45